import React, { Fragment, useContext, useEffect } from 'react'
import {Card, Divider, Grid, Segment, Sticky} from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import RequestReviewSteps from './steps/RequestReviewSteps';
import { RootStoreContext } from '../../../../App/stores/RootStore'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { RouteComponentProps } from 'react-router-dom';
import LoadingComponent from "../../../../App/layout/LoadingComponent";
import RequestReviewDocuments from "./documents/RequestReviewDocuments";
import RequestReviewDetails from "./RequestReviewDetails";
import RequestReviewSummary from "./RequestReviewSummary";
import RequestReviewNotes from "./notes/RequestReviewNotes";

interface RequestReviewParams {
    id: string
}

const RequestReview: React.FC<RouteComponentProps<RequestReviewParams>> = ({ match }) => {
    const rootStore = useContext(RootStoreContext)
    const { loadRequestReview, loadingInitial } = rootStore.requestReviewStore;
    const { loadPriorReviewSummary } = rootStore.priorReviewSummaryStore;
    const { loadRequestReviewDocuments } = rootStore.requestReviewDocumentStore;
    const { loadRequestReviewNotes, requestReviewNoteCount } = rootStore.requestReviewNoteStore;
    const { loadRequestNotes } = rootStore.requestNoteStore;
    const id = match.params.id;
    const { RequestReview: RV } = rootStore.requestReviewStore;

    useEffect(() => {
        loadRequestReview(id);
        loadRequestReviewDocuments(id);
        loadPriorReviewSummary(id);
        loadRequestReviewNotes(id);
        loadRequestNotes(id);
    }, [loadRequestReview, loadRequestReviewDocuments]);

    return (
        <Fragment>
            <LoadingComponent active={loadingInitial} content='Loading Review...' />
            <Sticky offset={70} >
                <Card fluid>
                    <Card.Content>
                        <Card.Description>
                            <RequestReviewDetails />
                            {RV?.reviewEnd === null ? <RequestReviewSteps /> : ""}
                        </Card.Description>
                    </Card.Content>
                </Card>

            </Sticky>
            <Card fluid>
                <Card.Content>
                    <Card.Header>
                        Documents
                    </Card.Header>
                    <Divider />
                    <Card.Description>
                        <RequestReviewDocuments />
                    </Card.Description>
                </Card.Content>
            </Card>
            <Card fluid>
                <Card.Content>
                    <Card.Header>Notes</Card.Header>
                    <Divider />
                    <Card.Description>
                        <RequestReviewSummary />
                        {requestReviewNoteCount > 0 ? <RequestReviewNotes /> : null}
                    </Card.Description>
                </Card.Content>
            </Card>

            {/*<Grid columns={1} >*/}
            {/*    */}


            {/*    <Grid.Column>*/}
            {/*        <Grid.Row>*/}
            {/*            */}
            {/*        </Grid.Row>*/}
            {/*        <Grid.Row>*/}
            {/*            */}
            {/*        </Grid.Row>*/}
            {/*        <Divider />*/}
            {/*        <Grid.Row>*/}
            {/*           */}
            {/*        </Grid.Row>*/}
            {/*    </Grid.Column>*/}
            {/*</Grid>*/}
        </Fragment>
    )
}
export default observer(RequestReview);